import { Reveal } from "@/components/Reveal";
import { site } from "@/content/site";
import { SEO } from "@/components/SEO";
import { CoverTile } from "@/components/CoverTile";
import { StreamRow } from "@/components/StreamRow";

export default function Music() {
  const featured = site.releases.find((r) => r.id === site.featuredReleaseId)!;
  const releases = site.releases;

  return (
    <>
      <SEO
        title="Music | EVE Band — Official Releases & Streaming"
        description="THE SOUND OF EVE — stream every official single: The Day I Found You, Pretty, Limit, Mama, Destiny, Pulang Kembali, Garuda and more on Spotify, Apple Music and YouTube Music."
      />
      <section data-testid="music-page" className="pb-24 pt-32 lg:pb-32 lg:pt-40">
        <div className="container-eve">
          <Reveal>
            <p className="eyebrow mb-6">Music</p>
            <h1 className="font-display text-5xl uppercase leading-[0.95] sm:text-6xl lg:text-7xl">
              The sound of <span className="gradient-text">EVE</span>
            </h1>
          </Reveal>

          {/* Featured release */}
          <Reveal delay={0.1}>
            <div
              data-testid="music-featured-release"
              className="mt-16 grid gap-10 border border-white/10 bg-eve-surface/60 p-6 sm:p-10 lg:grid-cols-[minmax(0,4fr)_minmax(0,8fr)] lg:gap-16"
            >
              <CoverTile release={featured} testId="music-featured-cover" />
              <div className="flex flex-col justify-center">
                <span className="chip w-fit border-eve-cyan/40 text-eve-cyan">Latest release</span>
                <h2 className="mt-6 font-display text-4xl uppercase leading-[0.95] sm:text-5xl">
                  {featured.title}
                </h2>
                <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.3em] text-eve-silver">
                  {featured.type} · {featured.date}
                </p>
                <p className="mt-6 max-w-xl text-base leading-relaxed text-eve-silver">
                  {featured.description}
                </p>
                <div className="mt-9">
                  <p className="mb-4 font-mono text-[10px] uppercase tracking-[0.3em] text-white/35">
                    Stream on
                  </p>
                  <StreamRow platforms={featured.platforms} testPrefix="music-featured" />
                </div>
              </div>
            </div>
          </Reveal>

          {/* All releases */}
          <Reveal delay={0.05} className="mt-24">
            <h2 className="font-display text-3xl uppercase sm:text-4xl">
              All releases<span className="text-eve-cyan">.</span>
            </h2>
          </Reveal>
          <div className="mt-10 grid gap-8 sm:grid-cols-2 xl:grid-cols-4">
            {releases.map((r, i) => (
              <Reveal key={r.id} delay={0.06 * i}>
                <article data-testid={`release-card-${r.id}`} className="group h-full">
                  <CoverTile release={r} index={i + 1} testId={`release-cover-${r.id}`} />
                  <div className="pt-5">
                    <h3 className="font-display text-xl uppercase tracking-wide">{r.title}</h3>
                    <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.3em] text-eve-silver">
                      {r.type}
                      {r.date ? ` · ${r.date}` : ""}
                    </p>
                    <div className="mt-4">
                      <StreamRow platforms={r.platforms} testPrefix={`release-${r.id}`} compact />
                    </div>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
          <p className="mt-10 font-mono text-[10px] uppercase tracking-[0.3em] text-white/30">
            Every button opens the exact track on its official platform.
          </p>
        </div>
      </section>
    </>
  );
}
